var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCRUDPageLayout',{attrs:{"links":_vm.links}},[(!_vm.fetchingData)?_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ApplicationDetails',{attrs:{"application":_vm.application}})],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }